import { createFileRoute } from "@tanstack/react-router";
import ProgramEdit from "../../../../../../views/programs/ProgramEdit";

export const Route = createFileRoute("/_authenticated/user/advertising/programs/edit/$id")({
  component: ProgramEdit,
});
